import NetworkingOperations from "../index";

const PackagesBundles = () => {
	const url = process.env.REACT_APP_PACKAGES_BUNDLES;

	return NetworkingOperations.get({
		url,
		headers: {
			ordering: "PRICE",
		},
	}).then((res) => res);
};

export default PackagesBundles;
